import React from "react";
import { graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import ArrowSvg from "../arrowSvg";
import linkResolver from "../../utils/linkResolver";
import htmlLinkResolver from "../../utils/htmlLinkResolver";

export const fragments = graphql`
  fragment FocusArea_Boxes on PrismicFocusAreaDataBodyBoxes {
    id
    slice_type
    primary {
      boxes_title {
        text
      }
    }
    items {
      boxes_cards_title {
        text
      }
      boxes_cards_text {
        text
        richText
        html
      }
      boxes_cards_icon {
        alt
        gatsbyImageData(layout: CONSTRAINED, height: 60, width: 60)
      }
      boxes_cards_cta_label
      boxes_cards_cta_link {
        url
      }
    }
  }
  fragment Page_Boxes on PrismicPageDataBodyBoxes {
    id
    slice_type
    primary {
      boxes_title {
        text
      }
    }
    items {
      boxes_cards_title {
        text
      }
      boxes_cards_text {
        text
        richText
        html
      }
      boxes_cards_icon {
        alt
        gatsbyImageData(layout: CONSTRAINED, height: 60, width: 60)
      }
      boxes_cards_cta_label
      boxes_cards_cta_link {
        url
      }
    }
  }
`;

function Boxes({ data }) {
  return (
    <div className="boxes">
      <h2 className="h3">{data?.primary?.boxes_title?.text}</h2>
      <div className="boxes__row">
        {data?.items?.map((box, idx) => (
          <div className="boxes__col" key={idx}>
            <div className="boxes__item">
              {box?.boxes_cards_icon && (
                <GatsbyImage
                  image={box?.boxes_cards_icon?.gatsbyImageData}
                  className="boxes__item--icon"
                  alt={
                    box?.boxes_cards_icon?.alt
                      ? box?.boxes_cards_icon?.alt
                      : box?.boxes_cards_title?.text
                  }
                />
              )}
              <h3 className="h6">{box?.boxes_cards_title?.text}</h3>
              <div className="rich-text" dangerouslySetInnerHTML={{ __html: htmlLinkResolver(box?.boxes_cards_text?.html) }} />
              {
                box?.boxes_cards_cta_label && box?.boxes_cards_cta_link?.url &&
                  <a href={linkResolver(box?.boxes_cards_cta_link)} className="boxes__item--cta">
                    <span>{box?.boxes_cards_cta_label}</span>
                    <ArrowSvg />
                  </a>
              }
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Boxes;
